<template>
  <div>
    <!-- banner part start-->
    <section class="banner_part">
      <v-container class="container">
        <v-layout row class="row align-items-center mt-xs-40">
          <v-flex lg7>
            <v-layout row class="banner_text">
              <v-flex class="banner_text_iner">
                <span v-if="getLang() == 'id'" v-html="banner.slogan.id"></span>
                <span v-else v-html="banner.slogan.en"></span>
                <div class="banner_btn">
                  <a href="#sectionabout" class="btn_1" style="border-radius:30px;">click here for more</a>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- banner part start-->

    <!-- ads part start-->
    <section class="pt-10 pb-40" v-show="false">
      <v-container class="container">
        <v-layout row>
          <v-flex md12>
            <div class="text-center">
              
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- ads part end-->

    <!-- about part start-->
    <section id="sectionabout" class="about_part section_padding">
      <v-container class="container">
        <v-layout row wrap>
          <v-flex xs12 sm12 md7>
            <div class="about_text pr-xs-0 pr-md-0 pr-90">
              <div class="experiance">
                <h4>Daniel Wai Diabetes,<br />Thyroid And Hormone Clinic Pte. Ltd.</h4>
              </div>
              <h4 class="mt-xs-10 mt-40 mb-0" v-if="getLang() == 'id'" v-html="about.subheader.id"></h4>
              <h4 class="mt-xs-10 mt-40 mb-0" v-else v-html="about.subheader.en"></h4>
              <p class="mt-10" v-if="getLang() == 'id'" v-html="about.desc.id"></p>
              <p class="mt-10" v-else v-html="about.desc.en"></p>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md5>
            <div class="experiance_list mt-xs-50 mt-sm-50 mt-md-50">
              <h2 v-if="getLang() == 'id'" v-html="about.servicesheader.id"></h2>
              <h2 v-else v-html="about.servicesheader.en"></h2>
              <div v-if="getLang() == 'id'" class="experiance_list_iner mt-xs-30 mt-40">
                <div v-for="(serv, i) in about.services" :key="i" class="single_experiance_list">
                  <h5 v-if="serv.link == ''" v-html="serv.id"></h5>
                  <a v-else @click="gotopage('',serv.link)">
                    <h5 style="text-decoration: underline;" v-html="serv.id"></h5>
                  </a>
                </div>
              </div>
              <div v-else class="experiance_list_iner mt-xs-30 mt-40">
                <div v-for="(serv, i) in about.services" :key="i" class="single_experiance_list">
                  <h5 v-if="serv.link == ''" v-html="serv.en"></h5>
                  <a v-else @click="gotopage('',serv.link)">
                    <h5 style="text-decoration: underline;" v-html="serv.en"></h5>
                  </a>
                </div>
              </div>
              <div class="mt-40">
                <Ubie :key="ubieID" />
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- about part end-->

    <!-- profile part start-->
    <section id="profile" class="service_part section_padding">
       <v-container class="container mtb-50">
        <v-layout row class="justify-content-center">
          <v-flex md12>
            <div class="section_tittle text-center">
              <p v-if="getLang() == 'id'" class="font-14" v-html="about.profile.title.id"></p>
              <p v-else class="font-14" v-html="about.profile.title.en"></p>
              <h2 v-html="about.profile.name"></h2>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md12>
            <div class="single_service_part">
              <div class="single_service_text">
                <span class="flaticon-layers"><v-icon color="red" class="font-12">mdi-book-open-page-variant</v-icon></span>
                <h2 v-html="about.profile.degree"></h2>
                <div v-if="getLang() == 'id'">
                  <p v-for="(his, i) in about.profile.history" :key="i" class="mt-30 font-11" style="text-align: justify;" v-html="his.id"></p>
                </div>
                <div v-else>
                  <p v-for="(his, i) in about.profile.history" :key="i" class="mt-30 font-11" style="text-align: justify;" v-html="his.en"></p>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-50 mt-xs-10">
          <v-flex md12>
            <div class="single_service_part">
              <div class="single_service_text pt-xs-0 pb-xs-10">
                <h2>PROFESSIONAL APPOINTMENTS & SOCIETY MEMBERSHIPS</h2>
              </div>
            </div>
            <v-layout wrap class="single_service_part mlr-auto">
              <v-flex v-for="(item, i) in about.profile.memberships" :key="i" sm6 md4>
                <v-flex class="single_service_part active m-10 h-90">
                  <div class="single_service_text">
                    <span class="flaticon-layers" :style="item.bg">
                      <v-icon color="white" class="font-12">{{item.icon}}</v-icon>
                    </span>
                    <h5 class="mt-20" v-html="item.text"></h5>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-50 mt-xs-10">
          <v-flex md12>
            <div class="single_service_part">
              <div class="single_service_text pt-xs-0 pb-xs-10">
                <h2>AWARDS</h2>
              </div>
            </div>
            <v-layout wrap class="single_service_part mlr-auto">
              <v-flex v-for="(item, i) in about.profile.awards" :key="i" sm6 md4>
                <v-flex class="single_service_part active m-10 h-90">
                  <div class="single_service_text">
                    <span class="flaticon-layers" :style="item.bg">
                      <v-icon color="white" class="font-12">{{item.icon}}</v-icon>
                    </span>
                    <h5 class="mt-20" v-html="item.text"></h5>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-50 mt-xs-10">
          <v-flex md12>
            <div class="single_service_part">
              <div class="single_service_text pt-xs-0 pb-xs-10">
                <h2>PUBLICATIONS</h2>
              </div>
            </div>
            <v-layout wrap class="single_service_part pb-50 ptb-xs-20">
              <ol class="ordered-list w-90 ml-xs-0 text-left">
                <li v-for="(item, i) in about.profile.publications" :key="i">
                  <span v-html="gettwodigit(i+1)+'. '" class="m-0 p-0"></span>
                  <span v-html="item" class="m-0 pl-30"></span>
                </li>
              </ol>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-container>
    </section>
    <!-- profile part end-->
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import VueScrollTo from 'vue-scrollto';
  import Ubie from '../components/ubie'

  export default {
    props: {
      language: String
    },
    data () {
      return {
        ubieID: 1,
        banner: {
          slogan: {
            en: '<h1>COMMITTED <br/> TO RESTORE</h1>',
            id: '<h1>Komitmen Untuk Memulihkan</h1>'
          }
        },
        about: {
          header: 'Daniel Wai Diabetes,<br />Thyroid And Hormone Clinic Pte. Ltd.',
          subheader: {
            en: 'Balance in the endocrine or hormone system is essential to our health.',
            id: 'Keseimbangan di endokrin dan sistem hormon ditubuh adalah sangat penting untuk kesehatan kita.'
          },
          desc: {
            en: 'Diseases occur when this balance is lost. We are committed to restore the body\'s nature balance for our patients.',
            id: 'Sakit penyakit bisa terjadi ketika keseimbangan sistem hormon ditubuh kita hilang. Kita berkomitmen untuk memulihkan keseimbangan natural tubuh untuk para pasien kita.'
          },
          servicesheader: {
            en: 'Our <strong style="font-weight: 500;">Services</strong>',
            id: 'Our <strong style="font-weight: 500;">Services<br />(Jasa Pelayanan Kita)</strong>'
          },
          services: [
            {
              en: 'Diabetes Mellitus',
              id: 'Diabetes Mellitus<br />(Kencing Manis)',
              link: ''
            },
            {
              en: 'Thyroid diseases',
              id: 'Thyroid diseases<br />(Kelenjar gondok)',
              link: ''
            },
            {
              en: 'Cholesterol disorders',
              id: 'Cholesterol disorders<br />(Penyakit Kolestrol)',
              link: ''
            },
            {
              en: 'Hypertension',
              id: 'Hypertension<br />(Penyakit Darah Tinggi)',
              link: ''
            },
            {
              en: 'Obesity and metabolic diseases',
              id: 'Obesity and metabolic Diseases (Penyakit kegemukan & kelainan pencernaan)',
              link: ''
            },
            {
              en: 'more . . .',
              id: 'more (dan lain lain) . . .',
              link: '/services'
            }
          ],
          profile: {
            title: {
              en: 'Consultant Endocrinologist',
              id: 'Konsultan Endokrinologi'
            },
            name: 'Dr Daniel Wai Chun Hang',
            degree: 'MBBS, MRCP (UK), MMed (Int Med)',
            history: [
              {
                en: 'Dr Wai was born in Hong Kong and took the Ministry of Education scholarship to study in Singapore, and had decided to make Singapore his home since then. He obtained his Bachelor of Medicine and Bachelor of Surgery degree from the National University of Singapore in 1998. He obtained his membership of the Royal College of Physician (United Kingdom) and Master of Medicine (Internal Medicine) Singapore in 2001. He subsequently had his advanced specialist training in the Singapore General Hospital and completed it in 2006. From 2007 to 2008, he went to the Alfred Hospital and Baker Heart Research Institute in Melbourne, Australia for further training in management of lipid disorders. He ran the Lipid Clinic upon his return, treating many patients with hard-to-treat cholesterol problems. In 2010, he was made the Director of the Obesity and Metabolic Unit of his department, leading a team of doctors, dietitian, physiotherapist and psychologists to provide the medical and surgical treatment for obesity and cholesterol problems.',
                id: 'Dr Daniel Wai lahir di Hong Kong dan mendapat beasiswa dari Pendidikan Pemerintah untuk belajar di Singapura, dan sejak itu Dr Daniel sudah memutuskan Singapura sebagai rumahnya. Dr Daniel memperoleh Sarjana ilmu kedokteran dan Sarjana ilmu bedah dari Universitas Nasional Singapura di tahun 1998. Dr Daniel memperoleh keanggotaan dari Royal College of Physician (United Kingdom) dan Master kedokteran (Internal Medicine) Singapura di tahun 2001. Dr Daniel kemudian mendapatkan Advanced Specialist Training di rumah sakit Singapore General Hospital dan menyelesaikan trainingnya di tahun 2006. Dari tahun 2007 sampai tahun 2008, Dr Daniel pergi ke rumah sakit Alfred dan Baker Heart Research Institute di Melbourne, Australia untuk training lebih lanjut di management lipid disorders. Setelah itu Dr Daniel kembali ke Singapura dan menjalankan Lipid Klinik dan mengobati banyak pasien dengan penyakit sulit masalah kolesterol. Di tahun 2010, Dr Daniel diberikan jabatan sebagai Direktor Obesity dan Metabolic Unit, memimpin tim dokter, ahli gizi, physioterapi dan psikologi untuk menyediakan pengobatan dan pelayanan operasi untuk pasien kegemukan dan masalah kolesterol.'
              },
              {
                en: 'Dr Wai had given over 135 local and international lectures over the years, on topics on diabetes, cholesterol, obesity and thyroid. The audience ranged from the public, medical students, physiotherapists, dietitians, traditional Chinese physicians, cardiologists, ophthalmologists and other internal medicine specialists. He was Adjunct Assistant Professor of the medical faculty of the National University of Medicine from October 2010 to Dec 2011.',
                id: 'Dr Daniel sudah memberikan lebih dari 135 lokal dan internasional pengajaran selama beberapa tahun ini sebagai dokter. Topik-topik pengajaran yang Dr Daniel berikan pengajaran adalah tentang kencing manis, kolesterol, kegemukan (obesitas) dan tiroid (kelenjar gondok). Para pendengarnya terdiri dari masyarakat umum, murid-murid kedokteran, physioterapi, ahli gizi, tradisional ahli kesehatan cina, dokter ahli jantung, dokter mata dan dokter ahli dalam. Dr Daniel ditunjuk sebagai Adjunct Assiten Profesor medical fakulti di National University of Singapore dari Oktober 2010 sampai Desember 2011.'
              },
              {
                en: 'Dr Wai was active in research and was principle investigator of studies in genetics of cholesterol, visceral fat, cardiovascular risk factors and thyroid eye disease, with funding from the National Medical Research Council and Biomedical Research Council. He was also regularly invited by those research institutes as a reviewer of research grant application, as well as reviewer of research papers in local and international journals.',
                id: 'Dr Daniel telah banyak menulis artikel-artikel kedokteran. Dr Daniel Wai pernah menjabat sebagai ketua penelitian di dalam pelajaran genetic, kolestrol, lemak visceral, resiko di kardiovaskular dan kelenjar gondok mata yang dibiayai oleh National Medical Research Council dan Biomedical Research Council. Dr Daniel Wai juga sering diundang oleh Institusi penelitian sebagai juri untuk menentukan pemenang akan aplikasi dana bantuan untuk sebuah penelitian. Dr Daniel juga pernah menjabat sebagai juri untuk tulisan penelitian di lokal dan internasional jurnal.'
              },
              {
                en: 'As interesting as leadership, teaching and research are, Dr Wai remains most passionate about patient care. He was awarded the Service with A Heart Award by the Singapore General Hospital 3 times, in recognition of the excellent service he had given to his patients. He speaks English, Mandarin, Cantonese and Bahasa Indonesia. He was regularly interviewed by the Media regarding topics on obesity, diabetes and cholesterol care (see Media section).',
                id: 'Walaupun Dr Daniel Wai tertarik dengan kepemimpinan, pengajaran dan penelitian, tetapi Dr Daniel paling tertarik dengan menjaga pasien-pasiennya. Dr Daniel mendapat penghargaan Pelayanan dengan Hati (Service with a Heart) oleh Singapore General Hospital sebanyak 3 kali untuk menghargai akan jasa-jasa Dr Daniel Wai yang istimewa kepada para pasien-pasiennya. Dr Daniel Wai bisa berbahasa Inggris, Mandarin, Cantonese dan Bahasa Indonesia. Dr Daniel juga sering diundang ke berbagai media untuk menbicarakan/menulis artikel tentang penyakit kegemukan, kencing manis dan cara merawat atau mencegah penyakit kolestrol (lihat dibagian Media).'
              }
            ],
            memberships:[
              {
                icon: 'mdi-account-outline',
                bg: 'background: red;',
                text: 'Member, Singapore Medical Association, 1999 until now',
              },
              {
                icon: 'mdi-account-multiple-outline',
                bg: 'background: blue;',
                text: 'Member, Endocrinology & Metabolic Society of Singapore, 2008 until now',
              },
              {
                icon: 'mdi-account-group-outline',
                bg: 'background: orange;',
                text: 'Member, Singapore Association of the Study of Obesity, 2010 until now',
              },
              {
                icon: 'mdi-medical-bag',
                bg: 'background: green;',
                text: 'Clinical Tutor, Yong Loo Lin School of Medicine, Naitonal University of Singapore, 2005-2010',
              },
              {
                icon: 'mdi-pill',
                bg: 'background: pink;',
                text: 'Clinical Teacher, Yong Loo Lin School of Medicine, Naitonal University of Singapore, June-Oct 2010',
              },
              {
                icon: 'mdi-teach',
                bg: 'background: purple;',
                text: 'Adjunct Assistant Professor, Yong Loo Lin School of Medicine, Naitonal University of Singapore, 2010-2011',
              }
            ],
            awards: [
              {
                icon: 'mdi-wallet-travel',
                bg: 'background: #e8b923;',
                text: 'Travel Grant for 13th International Symposium on Atherosclerosis, 2003',
              },
              {
                icon: 'mdi-bottle-tonic-plus-outline',
                bg: 'background: #e8b923;',
                text: 'Health Manpower Development Plan Fellowship Award, Ministry of Health, 2006',
              },
              {
                icon: 'mdi-heart-multiple-outline',
                bg: 'background: #e8b923;',
                text: 'Service With A Heart Award, Singapore General Hospital, April 2007',
              },
              {
                icon: 'mdi-heart-multiple-outline',
                bg: 'background: #e8b923;',
                text: 'Service With A Heart Award, Singapore General Hospital, March 2009',
              },
              {
                icon: 'mdi-hospital-building',
                bg: 'background: #e8b923;',
                text: '10 Years Long Service Award, Singapore General Hospital, August 2009',
              },
              {
                icon: 'mdi-heart-multiple-outline',
                bg: 'background: #e8b923;',
                text: 'Service With A Heart Award, Singapore General Hospital, Dec 2010',
              }
            ],
            publications: [
              '<b>Wai DC</b>, Ho SC, Seah LL, Fong KS, Khoo DH. Severe Graves\' ophthalmopathy after retrobulbar anesthesia for cataract extraction in a patient with mild stable thyroid eye disease. Thyroid. 2003 Aug;13(8):823-6.',
              'Tan CE, Ma S, <b>Wai D</b>, Chew SK, Tai ES. Can we apply the National Cholesterol Education Program Adult Treatment Panel definition of the metabolic syndrome to Asians? Diabetes Care. 2004 May;27(5):1182-6.',
              'Kekulawala JR, Murphy A, D\'Souza W, <b>Wai C</b>, Chin-Dusting J, Kingwell B, Sviridov D, Mukhamedova N. Impact of freezing on high-density lipoprotein functionality. Anal Biochem. 2008 Aug 15;379(2):213-5.',
              'Khoo CM, Tan M, Wu Y, <b>Wai CH</b>, Tavintharan S, Lee J, Tai ES. Central obesity and smoking are key modifiable risk factors for elevated C-reactive protein in Asian individuals who are not eligible for statin therapy. Nutrition & Diabetes (in press).',
              'Tan HC, Tai ES, Sviridov D, Nestel P, Ng C, Chan E, Teo Y, <b>Wai DCH</b>. Relationships between cholesterol efflux and high-density lipoprotein particles in patients with type 2 diabetes mellitus. Journal of Clinical Lipidology. 2011 Nov;5(6):467-73. Epub 2011 Jun 28.',
              'Lee SY, Lim CH, Pasupathy S, Poopalalingam R, Tham KW, Ganguly S, <b>Wai CHD</b>, Wong WK. Laparoscopic sleeve gastrectomy: a novel procedure for weight loss. Singapore Med J 2011; 52(11): 794.',
              'Tham KW, <b>Wai DCH</b>, Dr Eng AEK, Pasupathy S. Metabolic Surgery: A New Approach in the Treatment of Metabolic Disease of the 21st Century. The Singapore Family Physician; 37(4): (Supp 2): 29-34.',
              'Tan M, <b>Wai D</b>, Chng CL, Hwang W. Acarbose is an effective treatment for severe hypertriglyceridemia secondary to L-asparaginase and dexamethasone". Leuk Lymphoma. 2011 Dec 9. [Epub ahead of print]',
              '23 Scientific Paper Presentation in Scientific Meetings',
              'Ng AC, <b>Wai DC</b>, Tai ES, Ng KM and Chan LL. Visceral adipose tissue, but not waist circumference is a better measure of metabolic risk in Singaporean Chinese and Indian men. Nutrition and Diabetes (2012) 2, e38; doi:10.1038/nutd.2012.12. <a href="http://www.nature.com/nutd/journal/v2/n8/full/nutd201212a.html" target="_blank">click here for more details</a>',
              'Khoo CM, Tan LSM, Wu Y, <b>Wai CHD</b>, Subramaniam T, Tai ES, Lee J. Prevalence and control of hypercholesterolaemia as defined by NCEP-ATPIII guidelines and predictors of LDL-C goal attainment in a multi-ethnic Asian population. Annals, Academy of Medicine, Singapore',
            ],
          }
        }
      }
    },
    components: {
      Ubie
    },
    methods: {
      getLang() {
        // return this.$route.query.lang;
        this.language = this.$cookies.get('whatlang');
        return this.language;
      },
      gettwodigit(n) {
        return n > 9 ? "" + n: "0" + n;
      },
      gotopage: function (hash,page) {
        if (hash === '#toppage') {
          VueScrollTo.scrollTo(hash, "", "")
          setTimeout(() => {
            this.$router.push(page)
          }, 500);
        } else if (hash === 'window') {
          window.open(page, '_blank')
        } else {
          this.$router.push(page)
          setTimeout(() => {
            VueScrollTo.scrollTo(hash, "", "")
          }, 500);
        }
      },
      ...mapActions([]),
      ...mapMutations(['set_vsnackbar_Show', 'set_vsnackbar_Msg']),
    },
    computed: {
      ...mapState({
      })
    },
    watch: {
    },
    mounted() {
      if (localStorage.getItem('reloaded')) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem('reloaded');
        this.ubieID = 1
        if (location.hash == "#/#profile") {
          VueScrollTo.scrollTo('#profile', "", "")
        }
      } else {
          // Set a flag so that we know not to reload the page twice.
          localStorage.setItem('reloaded', '1');
          location.reload();
          this.ubieID += 1
      }
    },
  }
</script>

<style>
/* .bg-main-home{ background: url("../assets/img/home-bg.jpg") no-repeat center; background-size: cover; } */
</style>